import { epiResolveLanguage } from './EpiResolveLanguage';

export default {
    getContentByContentLink: <T>(
        contentLink: string,
    ) => {
        var lang = epiResolveLanguage();
        // Det er 'Accept-Language' header som bestemmer språk, culture er bare med som en hack for å unngå cache
        return fetch(`/api/mt1534/CMSProxy/v3.0/content/${contentLink}?culture=${lang}`, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Accept-Language': lang
            }
        })
    }
};

export function getValutaBenevnelse<T>() {
    const lang = epiResolveLanguage();

    return fetch(
        `/api/mt1534/CMSProxy/LKNO/forsideside?culture=` + lang, {
        headers:
        {
            'Content-Type': 'application/json',
        },
    }
    )
};
